export default __webpack_public_path__ + "static/media/not-found.73fc884a.svg";